import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["searchValue", "limit"],
  _excluded2 = ["data"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useInfiniteQuery } from '@tanstack/react-query';
import track from 'utils/track';
import api from 'utils/api';
import contentKeys from './queryKeys';
/*
 * useFetchMySearchContent
 */
export default function useFetchMySearchContent(_ref) {
  var _data$pages, _data$pages2;
  var searchValue = _ref.searchValue,
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? 24 : _ref$limit,
    options = _objectWithoutProperties(_ref, _excluded);
  // Tracking action
  // If the limit is 5
  // -> assume it's a 'presearch'
  // -> otherwise it's a 'search'
  var action = limit === 5 ? 'presearch' : 'search';

  // Request browse response
  function fetchContent(_x) {
    return _fetchContent.apply(this, arguments);
  }
  function _fetchContent() {
    _fetchContent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var _data$items;
      var pageParam, resolvedPageParam, offset, data;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            pageParam = _ref2.pageParam;
            resolvedPageParam = pageParam;
            offset = (resolvedPageParam === null || resolvedPageParam === void 0 ? void 0 : resolvedPageParam.offset) || 0;
            _context.next = 1;
            return api('get', '/api/me/content/search', _objectSpread({
              query: searchValue,
              offset: offset,
              limit: limit
            }, resolvedPageParam));
          case 1:
            data = _context.sent;
            // Tracking
            track('content', action, searchValue, offset + ((_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items.length));
            return _context.abrupt("return", data);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchContent.apply(this, arguments);
  }
  var _useInfiniteQuery = useInfiniteQuery(_objectSpread(_objectSpread({}, options), {}, {
      queryKey: contentKeys.mySearchContent(searchValue, action),
      queryFn: fetchContent,
      initialPageParam: undefined,
      getNextPageParam: function getNextPageParam(_ref3) {
        var nextOffset = _ref3.nextOffset;
        return nextOffset ? {
          offset: nextOffset
        } : undefined;
      },
      enabled: Boolean(searchValue)
    })),
    data = _useInfiniteQuery.data,
    queryProps = _objectWithoutProperties(_useInfiniteQuery, _excluded2);
  var items = (data === null || data === void 0 || (_data$pages = data.pages) === null || _data$pages === void 0 ? void 0 : _data$pages.flatMap(function (_ref4) {
    var items = _ref4.items;
    return items;
  })) || [];
  var meta = data === null || data === void 0 || (_data$pages2 = data.pages) === null || _data$pages2 === void 0 || (_data$pages2 = _data$pages2[0]) === null || _data$pages2 === void 0 ? void 0 : _data$pages2.meta;
  return _objectSpread({
    items: items,
    meta: meta
  }, queryProps);
}